import { render, staticRenderFns } from "./zoumadeng_set.vue?vue&type=template&id=68b0d1e9"
import script from "./zoumadeng_set.vue?vue&type=script&lang=js"
export * from "./zoumadeng_set.vue?vue&type=script&lang=js"
import style0 from "./zoumadeng_set.vue?vue&type=style&index=0&id=68b0d1e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports